import type { Route } from '@angular/router';
import type { MarketingPageId } from './marketing-pages';
import { MARKETING_PAGES } from './marketing-pages';

type NonHomePageId = Exclude<MarketingPageId, 'home'>;

const toRoutePath = (pageId: MarketingPageId): string => {
  const path = MARKETING_PAGES[pageId].path;
  return path === '/' ? '' : path.slice(1);
};

const createPageRoute = (pageId: NonHomePageId, loadComponent: NonNullable<Route['loadComponent']>): Route => ({
  path: toRoutePath(pageId),
  data: { pageId },
  loadComponent
});

export const appRoutes: Route[] = [
  {
    path: '',
    data: { pageId: 'home' as MarketingPageId },
    loadComponent: () => import('./pages/home-page.component').then((m) => m.HomePageComponent)
  },
  createPageRoute('pricing', () => import('./pages/pricing-page.component').then((m) => m.PricingPageComponent)),
  createPageRoute('lp-clockwise-alternative', () =>
    import('./pages/clockwise-alternative-page.component').then((m) => m.ClockwiseAlternativePageComponent)
  ),
  createPageRoute('feature-true-availability', () =>
    import('./pages/true-availability-page.component').then((m) => m.TrueAvailabilityPageComponent)
  ),
  createPageRoute('feature-calendar-ui', () =>
    import('./pages/calendar-ui-page.component').then((m) => m.CalendarUiPageComponent)
  ),
  createPageRoute('feature-meeting-polling', () =>
    import('./pages/meeting-polling-page.component').then((m) => m.MeetingPollingPageComponent)
  ),
  createPageRoute('feature-smart-booking', () =>
    import('./pages/smart-booking-page.component').then((m) => m.SmartBookingPageComponent)
  ),
  createPageRoute('roadmap', () => import('./pages/roadmap-page.component').then((m) => m.RoadmapPageComponent)),
  createPageRoute('solution-consultants', () =>
    import('./pages/independent-consultants-page.component').then((m) => m.IndependentConsultantsPageComponent)
  ),
  createPageRoute('solution-sales', () =>
    import('./pages/sales-teams-page.component').then((m) => m.SalesTeamsPageComponent)
  ),
  createPageRoute('about', () => import('./pages/about-page.component').then((m) => m.AboutPageComponent)),
  createPageRoute('contact', () => import('./pages/contact-page.component').then((m) => m.ContactPageComponent)),
  createPageRoute('privacy-policy', () =>
    import('./pages/privacy-policy-page.component').then((m) => m.PrivacyPolicyPageComponent)
  ),
  createPageRoute('terms-of-service', () =>
    import('./pages/terms-of-service-page.component').then((m) => m.TermsOfServicePageComponent)
  ),
  { path: '**', redirectTo: '' }
];
